import { useEffect } from 'react'

import { auth } from '@/lib/auth'
import { SignInCard } from '@/components/auth/sign-in-card/sign-in-card'
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'

export const Route = createFileRoute('/sign-in/')({
  validateSearch: (
    search?: Record<string, unknown>,
  ): { redirect?: string } => ({
    redirect: search?.redirect as string,
  }),
  component: SignInComponent,
  head: () => ({
    meta: [
      {
        name: 'Sign in to SUL AI Admin',
        content: 'Sign in to SUL AI Admin',
      },
      {
        title: 'SUL AI Admin | Sign In',
      },
    ],
  }),
})

export function SignInComponent() {
  const { data: session } = auth.useSession()
  const navigate = useNavigate()
  const search = useSearch({ from: '/sign-in/' })

  const safeSearchRedirect =
    search.redirect &&
    search.redirect.startsWith('/') &&
    !search.redirect.startsWith('//')
      ? search.redirect
      : '/'

  useEffect(() => {
    if (session) {
      navigate({ to: safeSearchRedirect })
    }
  }, [session, navigate, safeSearchRedirect])

  if (session) {
    return <div>Signing in...</div>
  }

  return (
    <div className="grid min-h-svh grid-rows-[auto_1fr]">
      <main className="overflow-auto">
        <div className="flex h-full flex-col items-center justify-center p-6 md:p-10">
          <div className="w-full max-w-sm md:max-w-4xl">
            <SignInCard redirect={safeSearchRedirect} />
          </div>
        </div>
      </main>
    </div>
  )
}
